import styled from 'styled-components';
import { Alert as BoltAlert, Button } from '@sainsburys-tech/bolt'; // COLOUR & FABRIC CONTENT STYLES

var AboutFabricButtonWrapper = styled.button.withConfig({
  displayName: "DrawerContentstyles__AboutFabricButtonWrapper",
  componentId: "j8mm5y-0"
})(["display:flex;align-items:stretch;width:100%;border:1px solid ", ";padding:15px 10px;font:inherit;background:none;border-radius:4px;margin-top:10px;"], function (props) {
  return props.theme.color.monochrome.light;
});
var AboutFabricText = styled.span.withConfig({
  displayName: "DrawerContentstyles__AboutFabricText",
  componentId: "j8mm5y-1"
})(["flex:1;text-align:left;font-weight:", ";font-size:", ";line-height:", ";"], function (props) {
  return props.theme.font.weight['semi-bold'];
}, function (props) {
  return props.theme.font.size['body-2'];
}, function (props) {
  return props.theme.font['line-height']['body-1'];
});
var AboutFabricIconWrapper = styled.span.withConfig({
  displayName: "DrawerContentstyles__AboutFabricIconWrapper",
  componentId: "j8mm5y-2"
})(["flex-basis:24px;display:flex;justify-content:center;align-items:center;padding-right:10px;"]); // FABRIC INFORMATION CONTENT STYLES

var FabricHeaderLabel = styled.span.withConfig({
  displayName: "DrawerContentstyles__FabricHeaderLabel",
  componentId: "j8mm5y-3"
})(["font-size:", ";"], function (props) {
  return props.theme.font.size['display-1'];
});
var InformationButtonWrapper = styled.button.withConfig({
  displayName: "DrawerContentstyles__InformationButtonWrapper",
  componentId: "j8mm5y-4"
})(["display:flex;align-items:stretch;width:100%;border:1px solid ", ";padding:15px 10px;font:inherit;background:none;border-radius:4px;"], function (props) {
  return props.theme.color.monochrome.light;
});
var InformationText = styled.span.withConfig({
  displayName: "DrawerContentstyles__InformationText",
  componentId: "j8mm5y-5"
})(["flex:1;text-align:left;font-weight:", ";font-size:", ";line-height:", ";"], function (props) {
  return props.theme.font.weight['semi-bold'];
}, function (props) {
  return props.theme.font.size['display-1'];
}, function (props) {
  return props.theme.font['line-height']['label-1'];
});
var InformationIconWrapper = styled.span.withConfig({
  displayName: "DrawerContentstyles__InformationIconWrapper",
  componentId: "j8mm5y-6"
})(["flex-basis:24px;display:flex;justify-content:center;align-items:center;padding-right:10px;"]);
var AlertWrapper = styled.div.withConfig({
  displayName: "DrawerContentstyles__AlertWrapper",
  componentId: "j8mm5y-7"
})(["margin-bottom:10px;"]); // TODO: Remove when Alert component is used from Fable

var Alert = styled(BoltAlert).withConfig({
  displayName: "DrawerContentstyles__Alert",
  componentId: "j8mm5y-8"
})(["font-weight:normal;line-height:", ";border:1px solid ", ";border-radius:2px;padding:15px;margin:0 0 20px;"], function (props) {
  return props.theme.font['line-height']['body-1'];
}, function (props) {
  return props.theme.color.palette['blue-90'];
});
var AboutFabricWrapper = styled.div.withConfig({
  displayName: "DrawerContentstyles__AboutFabricWrapper",
  componentId: "j8mm5y-9"
})(["padding:15px 0;border-top:1px solid ", ";"], function (props) {
  return props.theme.color.monochrome.light;
});
var AboutFabricHeading = styled.span.withConfig({
  displayName: "DrawerContentstyles__AboutFabricHeading",
  componentId: "j8mm5y-10"
})(["display:block;font-size:", ";font-weight:", ";margin-bottom:15px;"], function (props) {
  return props.theme.font.size['display-1'];
}, function (props) {
  return props.theme.font.weight.bold;
});
var AboutFabricTagWrapper = styled.div.withConfig({
  displayName: "DrawerContentstyles__AboutFabricTagWrapper",
  componentId: "j8mm5y-11"
})(["display:flex;flex-direction:row;"]);
var AboutFabricTag = styled.span.withConfig({
  displayName: "DrawerContentstyles__AboutFabricTag",
  componentId: "j8mm5y-12"
})(["border:1px solid ", ";color:", ";margin-right:10px;padding:0 8px;border-radius:2px;"], function (props) {
  return props.theme.color.semantic.info.light;
}, function (props) {
  return props.theme.color.semantic.info.light;
});
var AboutFabricDescription = styled.p.withConfig({
  displayName: "DrawerContentstyles__AboutFabricDescription",
  componentId: "j8mm5y-13"
})(["margin-top:10px;white-space:pre-line;"]);
var AboutFabricsTitle = styled(AboutFabricHeading).withConfig({
  displayName: "DrawerContentstyles__AboutFabricsTitle",
  componentId: "j8mm5y-14"
})(["margin-bottom:24px;"]);
var FabricInfoButtonWraper = styled.div.withConfig({
  displayName: "DrawerContentstyles__FabricInfoButtonWraper",
  componentId: "j8mm5y-15"
})(["margin-top:15px;"]);
var FabricInfoBackButton = styled(Button).withConfig({
  displayName: "DrawerContentstyles__FabricInfoBackButton",
  componentId: "j8mm5y-16"
})(["display:flex;align-items:center;margin:0 0 16px 0;padding:0;svg{width:24px;height:24px;}"]);
export { AboutFabricButtonWrapper, AboutFabricText, AboutFabricIconWrapper, InformationButtonWrapper, FabricHeaderLabel, InformationText, InformationIconWrapper, AlertWrapper, Alert, AboutFabricHeading, AboutFabricWrapper, AboutFabricTag, AboutFabricTagWrapper, AboutFabricDescription, AboutFabricsTitle, FabricInfoButtonWraper, FabricInfoBackButton };